import { AppointablePostDTO } from "@gymflow/types";

import { AppointableFormValues } from "../types";

export const mapFormValuesToPostDTO = (
  form: AppointableFormValues,
  clubId: number,
): AppointablePostDTO => {
  const {
    name,
    description,
    appointmentTerms,
    duration,
    blockExtraTime,
    bookingPossibleEvery,
    category,
    isMembersOnly,
    isTopOfTheHour,
  } = form.details;

  const {
    pricingStructure,
    typeOfCost,
    credits,
    price: { incTaxPrice: priceIncTaxPrice, salesTaxRate },
    isUpfrontPaymentRequired,
    membersPrice: { incTaxPrice: membersPriceIncTaxPrice },
    isShowMembersPrice,
  } = form.pricingStructure;

  const {
    resourceRequired,
    appointmentHostsFacility,
    appointmentHostsStaff,
    otherResourcesRequired,
    otherResourcesFacility,
    otherResourcesStaff,
  } = form.resources;

  const availabilityType =
    resourceRequired === "STAFF"
      ? otherResourcesRequired === "YES"
        ? "STAFF_AND_FACILITY"
        : "STAFF"
      : otherResourcesRequired === "YES"
        ? "FACILITY_AND_STAFF"
        : "FACILITY";

  const appointableHostsIdList = ["STAFF_AND_FACILITY", "STAFF"].includes(
    availabilityType,
  )
    ? appointmentHostsStaff.map((s) => s.value.id)
    : otherResourcesStaff.map((s) => s.value.id);

  const appointableFacilitiesIdList = [
    "FACILITY_AND_STAFF",
    "FACILITY",
  ].includes(availabilityType)
    ? appointmentHostsFacility.map((f) => f.value.id)
    : otherResourcesFacility.map((f) => f.value.id);

  return {
    name: name || "",
    description: description || "",
    termsAndConditions: appointmentTerms || "",
    availabilityType,
    status: "ACTIVE",
    duration: duration?.value ?? 0,
    blockedTime: blockExtraTime?.value ?? 0,
    capacity: 1,
    pricingModel: pricingStructure === "FREE" ? "FREE" : "FIXED",
    price:
      ["PRICE", "BOTH"].includes(typeOfCost) &&
      priceIncTaxPrice !== undefined &&
      pricingStructure === "FIXED_PRICE"
        ? priceIncTaxPrice
        : undefined,
    membersOnlyPrice: {
      price:
        ["PRICE", "BOTH"].includes(typeOfCost) &&
        membersPriceIncTaxPrice !== undefined &&
        pricingStructure === "FIXED_PRICE" &&
        isShowMembersPrice
          ? membersPriceIncTaxPrice
          : null,
    },
    sessionCost:
      ["CREDITS", "BOTH"].includes(typeOfCost) &&
      credits !== undefined &&
      pricingStructure === "FIXED_PRICE"
        ? credits
        : undefined,
    taxRate:
      ["PRICE", "BOTH"].includes(typeOfCost) &&
      salesTaxRate !== undefined &&
      pricingStructure === "FIXED_PRICE"
        ? salesTaxRate
        : undefined,
    paymentUpfront: isUpfrontPaymentRequired,
    cardUpfront: false,
    forMembersOnly: isMembersOnly,
    slotAlignment: isTopOfTheHour ? "HOUR_START" : "ANYTIME",
    alignToInterval: bookingPossibleEvery
      ? bookingPossibleEvery.value
      : undefined,
    allowOnlineBookings: false,
    allowAppBookings: false,
    appointableCategoryId: category?.value ?? 0,
    appointableHostsIdList,
    appointableFacilitiesIdList,
    clubId,
  };
};
